import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { breadcrumbConfig, tokens } from '../../constants';
var getRowContainerStyle = () => {
  return {
    flexDirection: 'row',
    alignItems: 'center'
  };
};
var getIconStyle = () => {
  return {
    marginLeft: tokens.spacing.SPACING_2
  };
};
export var getBreadcrumbStyles = () => {
  return StyleSheet.create({
    rowContainer: getRowContainerStyle(),
    icon: getIconStyle(),
    marginRight: {
      marginRight: tokens.spacing.SPACING_4
    }
  });
};
export var getBreadcrumbProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(breadcrumbConfig === null || breadcrumbConfig === void 0 ? void 0 : breadcrumbConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.breadcrumb) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};